import React, { useState } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function LendEmployeesPage() {
    const ID = Cookies.get("log_id");
    const [Role,setRole] = useState("");
    const [department,setDepartment] = useState("");
    const [Description,setDescription] = useState("");
    const [Available,setAvailable] = useState("");
    const [from,setFrom] = useState("");
    const [to,setTo] = useState("");
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
      const navigate = useNavigate();
    function Lend_Employees(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('role',Role);
        formdata.append('department',department);
        formdata.append('description',Description);
        formdata.append('available',Available);
        formdata.append('from',from);
        formdata.append('to',to);
        axios.post(`${url.path}/lend_employees_company/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Request Submitted'
                })
                navigate("/lend_employees_cmp_page");
            }
        })
        .catch((err) => {
              if(!err.response.data.status){
                Swal.fire({
                  icon: "error",
                  title: `${err.response.data.message}`,
                });
              }
        });
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Lend Employees</h1>
                </div>
                <br />
                <form onSubmit={Lend_Employees}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Role</label>
                            <input type="text" value={Role} onChange={(e) =>setRole(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Department</label>
                            <input type="text" value={department} onChange={(e) =>setDepartment(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <input type="text" value={Description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                        
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Available Employees</label>
                            <input type="text" value={Available} onChange={(e) =>setAvailable(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>From</label>
                            <input type="date" value={from} onChange={(e) =>setFrom(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>To</label>
                            <input type="date" value={to} onChange={(e) =>setTo(e.target.value)} />
                        </div>
                    </div>
                    
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Lend</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default LendEmployeesPage;